import React from 'react';
import RoutesSwitch from './Routes';
import {Normalize} from 'styled-normalize';
import {ThemeProvider} from 'styled-components';
import {defaultTheme} from './ui-kit/theme/theme';
import 'antd/dist/antd.css';
import './ui-kit/fonts/fonts.css';
import './ui-kit/Modal/styles.css';
import {themes} from './ui-kit/theme/theme';
import {Layout as DesktopLayout} from './containers/Layout';
import CurrentUser from './containers/CurrentUser';
import RecoilProvider from './containers/RecoilProvider';
import {IsMobileVersion} from './helpers/helpers';
import {MobileLayout} from './mobile/containers/Layout';
import {THEME} from './constants/env';
import {useSetPageTitle} from './hooks/onboarding';

// Remap the hardcoded Proxima Nova / Majesti Banner families to the lvs fonts,
// loaded only for the lvs theme so other brands are untouched.
if (THEME === themes.lvs) {
  import('./ui-kit/fonts/fonts-lvs.css');
}

const Layout = IsMobileVersion ? MobileLayout : DesktopLayout;
function App() {
  useSetPageTitle();
  return (
    <>
      <RecoilProvider>
        <CurrentUser>
          <ThemeProvider theme={{...defaultTheme, current: THEME}}>
            <Layout>
              <RoutesSwitch />
            </Layout>
            <Normalize />
          </ThemeProvider>
        </CurrentUser>
      </RecoilProvider>
    </>
  );
}

export default App;
